import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";

// Coping Skills Modals
export const CopingSkillsModals = ({
  showCopingSkillsModal,
  setShowCopingSkillsModal,
  showEditCopingSkillsModal,
  setShowEditCopingSkillsModal,
  showDeleteCopingSkillsModal,
  setShowDeleteCopingSkillsModal,
  copingSkillsForm,
  setCopingSkillsForm,
  copingSkillsFormLoading,
  copingSkillsFormError,
  handleCreateCopingSkill,
  handleUpdateCopingSkill,
  handleDeleteCopingSkill,
  selectedCopingSkill,
  copingSkillToDelete,
  setCopingSkillToDelete
}) => {
  return (
    <>
      {/* Create Coping Skill Modal */}
      {showCopingSkillsModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-8 w-full max-w-md mx-4 max-h-[85vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold">Add Coping Skill</h2>
              <button
                onClick={() => setShowCopingSkillsModal(false)}
                className="text-slate-400 hover:text-slate-700"
              >
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>
            <form onSubmit={handleCreateCopingSkill}>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Short Description *
                  </label>
                  <input
                    type="text"
                    required
                    value={copingSkillsForm.short_description}
                    onChange={(e) => setCopingSkillsForm({ ...copingSkillsForm, short_description: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter short description"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Long Description
                  </label>
                  <textarea
                    value={copingSkillsForm.long_description}
                    onChange={(e) => setCopingSkillsForm({ ...copingSkillsForm, long_description: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter long description"
                    rows="4"
                  />
                </div>
              </div>
              {copingSkillsFormError && (
                <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                  {copingSkillsFormError}
                </div>
              )}
              <div className="flex gap-3 mt-6">
                <button
                  type="submit"
                  disabled={copingSkillsFormLoading}
                  className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
                >
                  {copingSkillsFormLoading ? "Creating..." : "Create"}
                </button>
                <button
                  type="button"
                  onClick={() => setShowCopingSkillsModal(false)}
                  className="px-4 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Coping Skill Modal */}
      {showEditCopingSkillsModal && selectedCopingSkill && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-8 w-full max-w-md mx-4 max-h-[85vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold">Edit Coping Skill</h2>
              <button
                onClick={() => setShowEditCopingSkillsModal(false)}
                className="text-slate-400 hover:text-slate-700"
              >
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>
            <form onSubmit={handleUpdateCopingSkill}>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Short Description *
                  </label>
                  <input
                    type="text"
                    required
                    value={copingSkillsForm.short_description}
                    onChange={(e) => setCopingSkillsForm({ ...copingSkillsForm, short_description: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter short description"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Long Description
                  </label>
                  <textarea
                    value={copingSkillsForm.long_description}
                    onChange={(e) => setCopingSkillsForm({ ...copingSkillsForm, long_description: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter long description"
                    rows="4"
                  />
                </div>
              </div>
              {copingSkillsFormError && (
                <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                  {copingSkillsFormError}
                </div>
              )}
              <div className="flex gap-3 mt-6">
                <button
                  type="submit"
                  disabled={copingSkillsFormLoading}
                  className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
                >
                  {copingSkillsFormLoading ? "Saving..." : "Save Changes"}
                </button>
                <button
                  type="button"
                  onClick={() => setShowEditCopingSkillsModal(false)}
                  className="px-4 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Coping Skill Modal */}
      {showDeleteCopingSkillsModal && copingSkillToDelete && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-6 w-full max-w-md mx-4 text-center">
            <h2 className="text-xl font-bold mb-4 text-red-700">Delete Coping Skill</h2>
            <p className="mb-6">Are you sure you want to delete <span className="font-semibold">{copingSkillToDelete.short_description}</span>? This action cannot be undone.</p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={handleDeleteCopingSkill}
                className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
              >
                Delete
              </button>
              <button
                onClick={() => { setShowDeleteCopingSkillsModal(false); setCopingSkillToDelete(null); }}
                className="px-6 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// Modality Modals
export const ModalityModals = ({
  showModalityModal,
  setShowModalityModal,
  showEditModalityModal,
  setShowEditModalityModal,
  showDeleteModalityModal,
  setShowDeleteModalityModal,
  showViewModalityModal,
  setShowViewModalityModal,
  modalityForm,
  setModalityForm,
  modalityFormLoading,
  modalityFormError,
  handleCreateModality,
  handleUpdateModality,
  handleDeleteModality,
  selectedModality,
  setSelectedModality,
  selectedModalityForView,
  modalityToDelete,
  setModalityToDelete
}) => {
  return (
    <>
      {/* Create Modality Modal */}
      {showModalityModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-8 w-full max-w-2xl mx-4 max-h-[85vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold">Add Modality</h2>
              <button onClick={() => setShowModalityModal(false)} className="text-slate-400 hover:text-slate-700">
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>
            <form onSubmit={handleCreateModality}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-slate-700 mb-1">Name *</label>
                  <input
                    type="text"
                    required
                    value={modalityForm.name}
                    onChange={(e) => setModalityForm({ ...modalityForm, name: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Short Term</label>
                  <input
                    type="text"
                    value={modalityForm.short_term}
                    onChange={(e) => setModalityForm({ ...modalityForm, short_term: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter short term"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Modality Setting</label>
                  <select
                    value={modalityForm.modality_setting}
                    onChange={(e) => setModalityForm({ ...modalityForm, modality_setting: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                  >
                    <option value="">Select...</option>
                    <option value="Individual">Individual</option>
                    <option value="Family">Family</option>
                    <option value="Couple">Couple</option>
                  </select>
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-slate-700 mb-1">Description</label>
                  <textarea
                    value={modalityForm.description}
                    onChange={(e) => setModalityForm({ ...modalityForm, description: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter description"
                    rows="5"
                  />
                </div>
              </div>
              {modalityFormError && (
                <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">{modalityFormError}</div>
              )}
              <div className="flex gap-3 mt-6">
                <button type="submit" disabled={modalityFormLoading} className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
                  {modalityFormLoading ? "Creating..." : "Create"}
                </button>
                <button type="button" onClick={() => setShowModalityModal(false)} className="px-4 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300">
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Modality Modal */}
      {showEditModalityModal && selectedModality && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-8 w-full max-w-2xl mx-4 max-h-[85vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold">Edit Modality</h2>
              <button onClick={() => setShowEditModalityModal(false)} className="text-slate-400 hover:text-slate-700">
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>
            <form onSubmit={handleUpdateModality}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-slate-700 mb-1">Name *</label>
                  <input
                    type="text"
                    required
                    value={modalityForm.name}
                    onChange={(e) => setModalityForm({ ...modalityForm, name: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Short Term</label>
                  <input
                    type="text"
                    value={modalityForm.short_term}
                    onChange={(e) => setModalityForm({ ...modalityForm, short_term: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter short term"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Modality Setting</label>
                  <select
                    value={modalityForm.modality_setting}
                    onChange={(e) => setModalityForm({ ...modalityForm, modality_setting: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                  >
                    <option value="">Select...</option>
                    <option value="Individual">Individual</option>
                    <option value="Family">Family</option>
                    <option value="Couple">Couple</option>
                  </select>
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-slate-700 mb-1">Description</label>
                  <textarea
                    value={modalityForm.description}
                    onChange={(e) => setModalityForm({ ...modalityForm, description: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter description"
                    rows="5"
                  />
                </div>
              </div>
              {modalityFormError && (
                <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">{modalityFormError}</div>
              )}
              <div className="flex gap-3 mt-6">
                <button type="submit" disabled={modalityFormLoading} className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
                  {modalityFormLoading ? "Saving..." : "Save Changes"}
                </button>
                <button type="button" onClick={() => setShowEditModalityModal(false)} className="px-4 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300">
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Modality Modal */}
      {showDeleteModalityModal && modalityToDelete && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-6 w-full max-w-md mx-4 text-center">
            <h2 className="text-xl font-bold mb-4 text-red-700">Delete Modality</h2>
            <p className="mb-6">Are you sure you want to delete <span className="font-semibold">{modalityToDelete.name}</span>? This action cannot be undone.</p>
            <div className="flex gap-3 justify-center">
              <button onClick={handleDeleteModality} className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700">Delete</button>
              <button onClick={() => { setShowDeleteModalityModal(false); setModalityToDelete(null); }} className="px-6 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300">Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* View Modality Modal */}
      {showViewModalityModal && selectedModalityForView && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-8 w-full max-w-3xl mx-4 max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-2xl font-bold text-slate-800">View Modality</h2>
              <button onClick={() => setShowViewModalityModal(false)} className="text-slate-400 hover:text-slate-700 transition-colors">
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>

            <div className="space-y-6">
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-2">Name</label>
                <div className="p-4 bg-slate-50 border border-slate-200 rounded-lg">
                  <span className="text-lg font-medium text-slate-900">{selectedModalityForView.name}</span>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">Short Term</label>
                  <div className="p-4 bg-slate-50 border border-slate-200 rounded-lg">{selectedModalityForView.short_term || '—'}</div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">Modality Setting</label>
                  <div className="p-4 bg-slate-50 border border-slate-200 rounded-lg">{selectedModalityForView.modality_setting || '—'}</div>
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-2">Description</label>
                <div className="p-4 bg-slate-50 border border-slate-200 rounded-lg max-h-96 overflow-y-auto">
                  <pre className="whitespace-pre-wrap text-slate-700 font-mono text-sm leading-relaxed">{selectedModalityForView.description || '—'}</pre>
                </div>
              </div>
            </div>

            <div className="flex justify-end mt-8 pt-6 border-t border-slate-200">
              <button onClick={() => setShowViewModalityModal(false)} className="px-6 py-2 bg-slate-600 text-white rounded-lg hover:bg-slate-700 transition-colors">Close</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// Modality Steps Modals
export const ModalityStepsModals = ({
  showModalityStepsModal,
  setShowModalityStepsModal,
  showEditModalityStepsModal,
  setShowEditModalityStepsModal,
  showDeleteModalityStepsModal,
  setShowDeleteModalityStepsModal,
  modalityStepsForm,
  setModalityStepsForm,
  modalityStepsFormLoading,
  modalityStepsFormError,
  handleCreateModalitySteps,
  handleUpdateModalitySteps,
  handleDeleteModalitySteps,
  selectedModalityStep,
  modalityStepToDelete,
  setModalityStepToDelete,
  modalities
}) => {
  return (
    <>
      {/* Create Modality Steps Modal */}
      {showModalityStepsModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-8 w-full max-w-2xl mx-4 max-h-[85vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold">Add Modality Steps</h2>
              <button onClick={() => setShowModalityStepsModal(false)} className="text-slate-400 hover:text-slate-700">
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>
            <form onSubmit={handleCreateModalitySteps}>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Modality *</label>
                  <select
                    required
                    value={modalityStepsForm.modality_id}
                    onChange={(e) => setModalityStepsForm({ ...modalityStepsForm, modality_id: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                  >
                    <option value="">Select...</option>
                    {modalities.map(m => (
                      <option key={m.id} value={m.id}>{m.name}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Name (one per line)</label>
                  <textarea
                    value={modalityStepsForm.name}
                    onChange={(e) => setModalityStepsForm({ ...modalityStepsForm, name: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 font-mono"
                    rows="10"
                    placeholder={`Enter steps, one per line\nEg:\nEngagement\nAssessment\nIntervention`}
                  />
                  {/* Grid lines effect */}
                  <style>{`.grid-lines { background-image: linear-gradient(transparent 23px, #e5e7eb 24px); background-size: 100% 24px; }`}</style>
                </div>
              </div>
              {modalityStepsFormError && (
                <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">{modalityStepsFormError}</div>
              )}
              <div className="flex gap-3 mt-6">
                <button type="submit" disabled={modalityStepsFormLoading} className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
                  {modalityStepsFormLoading ? "Creating..." : "Create"}
                </button>
                <button type="button" onClick={() => setShowModalityStepsModal(false)} className="px-4 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300">
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Modality Step Modal */}
      {showEditModalityStepsModal && selectedModalityStep && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-8 w-full max-w-lg mx-4 max-h-[85vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold">Edit Modality Step</h2>
              <button onClick={() => setShowEditModalityStepsModal(false)} className="text-slate-400 hover:text-slate-700">
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>
            <form onSubmit={handleUpdateModalitySteps}>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Modality *</label>
                  <select
                    required
                    value={modalityStepsForm.modality_id}
                    onChange={(e) => setModalityStepsForm({ ...modalityStepsForm, modality_id: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                  >
                    <option value="">Select...</option>
                    {modalities.map(m => (
                      <option key={m.id} value={m.id}>{m.name}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Name</label>
                  <input
                    type="text"
                    value={modalityStepsForm.name}
                    onChange={(e) => setModalityStepsForm({ ...modalityStepsForm, name: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
              {modalityStepsFormError && (
                <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">{modalityStepsFormError}</div>
              )}
              <div className="flex gap-3 mt-6">
                <button type="submit" disabled={modalityStepsFormLoading} className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
                  {modalityStepsFormLoading ? "Saving..." : "Save Changes"}
                </button>
                <button type="button" onClick={() => setShowEditModalityStepsModal(false)} className="px-4 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300">
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Modality Step Modal */}
      {showDeleteModalityStepsModal && modalityStepToDelete && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-6 w-full max-w-md mx-4 text-center">
            <h2 className="text-xl font-bold mb-4 text-red-700">Delete Modality Step</h2>
            <p className="mb-6">Are you sure you want to delete <span className="font-semibold">{modalityStepToDelete.name}</span>? This action cannot be undone.</p>
            <div className="flex gap-3 justify-center">
              <button onClick={handleDeleteModalitySteps} className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700">Delete</button>
              <button onClick={() => { setShowDeleteModalityStepsModal(false); setModalityStepToDelete(null); }} className="px-6 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300">Cancel</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// Activity Modals
export const ActivityModals = ({
  showActivityModal,
  setShowActivityModal,
  showEditActivityModal,
  setShowEditActivityModal,
  showDeleteActivityModal,
  setShowDeleteActivityModal,
  showViewActivityModal,
  setShowViewActivityModal,
  activityForm,
  setActivityForm,
  activityFormLoading,
  activityFormError,
  handleCreateActivity,
  handleUpdateActivity,
  handleDeleteActivity,
  selectedActivity,
  setSelectedActivity,
  selectedActivityForView,
  activityToDelete,
  setActivityToDelete
}) => {
  return (
    <>
      {/* Create Activity Modal */}
      {showActivityModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-8 w-full max-w-2xl mx-4 max-h-[85vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold">Add Activity</h2>
              <button onClick={() => setShowActivityModal(false)} className="text-slate-400 hover:text-slate-700">
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>
            <form onSubmit={handleCreateActivity}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-slate-700 mb-1">Name *</label>
                  <input
                    type="text"
                    required
                    value={activityForm.name}
                    onChange={(e) => setActivityForm({ ...activityForm, name: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Short Term</label>
                  <input
                    type="text"
                    value={activityForm.short_term}
                    onChange={(e) => setActivityForm({ ...activityForm, short_term: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter short term"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Activity Setting</label>
                  <select
                    value={activityForm.activity_setting}
                    onChange={(e) => setActivityForm({ ...activityForm, activity_setting: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                  >
                    <option value="">Select...</option>
                    <option value="Individual">Individual</option>
                    <option value="Family">Family</option>
                    <option value="Couple">Couple</option>
                  </select>
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-slate-700 mb-1">Description</label>
                  <textarea
                    value={activityForm.description}
                    onChange={(e) => setActivityForm({ ...activityForm, description: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter description"
                    rows="5"
                  />
                </div>
              </div>
              {activityFormError && (
                <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">{activityFormError}</div>
              )}
              <div className="flex gap-3 mt-6">
                <button type="submit" disabled={activityFormLoading} className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
                  {activityFormLoading ? "Creating..." : "Create"}
                </button>
                <button type="button" onClick={() => setShowActivityModal(false)} className="px-4 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300">
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Activity Modal */}
      {showEditActivityModal && selectedActivity && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-8 w-full max-w-2xl mx-4 max-h-[85vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold">Edit Activity</h2>
              <button onClick={() => setShowEditActivityModal(false)} className="text-slate-400 hover:text-slate-700">
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>
            <form onSubmit={handleUpdateActivity}>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-slate-700 mb-1">Name *</label>
                  <input
                    type="text"
                    required
                    value={activityForm.name}
                    onChange={(e) => setActivityForm({ ...activityForm, name: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Short Term</label>
                  <input
                    type="text"
                    value={activityForm.short_term}
                    onChange={(e) => setActivityForm({ ...activityForm, short_term: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter short term"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Activity Setting</label>
                  <select
                    value={activityForm.activity_setting}
                    onChange={(e) => setActivityForm({ ...activityForm, activity_setting: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                  >
                    <option value="">Select...</option>
                    <option value="Individual">Individual</option>
                    <option value="Family">Family</option>
                    <option value="Couple">Couple</option>
                  </select>
                </div>
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium text-slate-700 mb-1">Description</label>
                  <textarea
                    value={activityForm.description}
                    onChange={(e) => setActivityForm({ ...activityForm, description: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter description"
                    rows="5"
                  />
                </div>
              </div>
              {activityFormError && (
                <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">{activityFormError}</div>
              )}
              <div className="flex gap-3 mt-6">
                <button type="submit" disabled={activityFormLoading} className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
                  {activityFormLoading ? "Saving..." : "Save Changes"}
                </button>
                <button type="button" onClick={() => setShowEditActivityModal(false)} className="px-4 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300">
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Activity Modal */}
      {showDeleteActivityModal && activityToDelete && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-6 w-full max-w-md mx-4 text-center">
            <h2 className="text-xl font-bold mb-4 text-red-700">Delete Activity</h2>
            <p className="mb-6">Are you sure you want to delete <span className="font-semibold">{activityToDelete.name}</span>? This action cannot be undone.</p>
            <div className="flex gap-3 justify-center">
              <button onClick={handleDeleteActivity} className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700">Delete</button>
              <button onClick={() => { setShowDeleteActivityModal(false); setActivityToDelete(null); }} className="px-6 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300">Cancel</button>
            </div>
          </div>
        </div>
      )}

      {/* View Activity Modal */}
      {showViewActivityModal && selectedActivityForView && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-8 w-full max-w-3xl mx-4 max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-2xl font-bold text-slate-800">View Activity</h2>
              <button onClick={() => setShowViewActivityModal(false)} className="text-slate-400 hover:text-slate-700 transition-colors">
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>

            <div className="space-y-6">
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-2">Name</label>
                <div className="p-4 bg-slate-50 border border-slate-200 rounded-lg">
                  <span className="text-lg font-medium text-slate-900">{selectedActivityForView.name}</span>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">Short Term</label>
                  <div className="p-4 bg-slate-50 border border-slate-200 rounded-lg">{selectedActivityForView.short_term || '—'}</div>
                </div>
                <div>
                  <label className="block text-sm font-semibold text-slate-700 mb-2">Activity Setting</label>
                  <div className="p-4 bg-slate-50 border border-slate-200 rounded-lg">{selectedActivityForView.activity_setting || '—'}</div>
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-2">Description</label>
                <div className="p-4 bg-slate-50 border border-slate-200 rounded-lg max-h-96 overflow-y-auto">
                  <pre className="whitespace-pre-wrap text-slate-700 font-mono text-sm leading-relaxed">{selectedActivityForView.description || '—'}</pre>
                </div>
              </div>
            </div>

            <div className="flex justify-end mt-8 pt-6 border-t border-slate-200">
              <button onClick={() => setShowViewActivityModal(false)} className="px-6 py-2 bg-slate-600 text-white rounded-lg hover:bg-slate-700 transition-colors">Close</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// Sub-Activities Modals
export const SubActivitiesModals = ({
  showSubActivitiesModal,
  setShowSubActivitiesModal,
  showEditSubActivitiesModal,
  setShowEditSubActivitiesModal,
  showDeleteSubActivitiesModal,
  setShowDeleteSubActivitiesModal,
  subActivitiesForm,
  setSubActivitiesForm,
  subActivitiesFormLoading,
  subActivitiesFormError,
  handleCreateSubActivities,
  handleUpdateSubActivities,
  handleDeleteSubActivities,
  selectedSubActivity,
  subActivityToDelete,
  setSubActivityToDelete,
  activities
}) => {
  return (
    <>
      {/* Create Sub-Activities Modal */}
      {showSubActivitiesModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-8 w-full max-w-2xl mx-4 max-h-[85vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold">Add Sub-Activities</h2>
              <button onClick={() => setShowSubActivitiesModal(false)} className="text-slate-400 hover:text-slate-700">
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>
            <form onSubmit={handleCreateSubActivities}>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Activity *</label>
                  <select
                    required
                    value={subActivitiesForm.activity_id}
                    onChange={(e) => setSubActivitiesForm({ ...subActivitiesForm, activity_id: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                  >
                    <option value="">Select...</option>
                    {activities.map(a => (
                      <option key={a.id} value={a.id}>{a.name}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Name (one per line)</label>
                  <textarea
                    value={subActivitiesForm.name}
                    onChange={(e) => setSubActivitiesForm({ ...subActivitiesForm, name: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 font-mono"
                    rows="10"
                    placeholder={`Enter sub-activities, one per line\nEg:\nPlanning\nExecution\nReview`}
                  />
                </div>
              </div>
              {subActivitiesFormError && (
                <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">{subActivitiesFormError}</div>
              )}
              <div className="flex gap-3 mt-6">
                <button type="submit" disabled={subActivitiesFormLoading} className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
                  {subActivitiesFormLoading ? "Creating..." : "Create"}
                </button>
                <button type="button" onClick={() => setShowSubActivitiesModal(false)} className="px-4 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300">
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Sub-Activity Modal */}
      {showEditSubActivitiesModal && selectedSubActivity && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-8 w-full max-w-lg mx-4 max-h-[85vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold">Edit Sub-Activity</h2>
              <button onClick={() => setShowEditSubActivitiesModal(false)} className="text-slate-400 hover:text-slate-700">
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>
            <form onSubmit={handleUpdateSubActivities}>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Activity *</label>
                  <select
                    required
                    value={subActivitiesForm.activity_id}
                    onChange={(e) => setSubActivitiesForm({ ...subActivitiesForm, activity_id: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 bg-white"
                  >
                    <option value="">Select...</option>
                    {activities.map(a => (
                      <option key={a.id} value={a.id}>{a.name}</option>
                    ))}
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Name</label>
                  <input
                    type="text"
                    value={subActivitiesForm.name}
                    onChange={(e) => setSubActivitiesForm({ ...subActivitiesForm, name: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>
              {subActivitiesFormError && (
                <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">{subActivitiesFormError}</div>
              )}
              <div className="flex gap-3 mt-6">
                <button type="submit" disabled={subActivitiesFormLoading} className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
                  {subActivitiesFormLoading ? "Saving..." : "Save Changes"}
                </button>
                <button type="button" onClick={() => setShowEditSubActivitiesModal(false)} className="px-4 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300">
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Sub-Activity Modal */}
      {showDeleteSubActivitiesModal && subActivityToDelete && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-6 w-full max-w-md mx-4 text-center">
            <h2 className="text-xl font-bold mb-4 text-red-700">Delete Sub-Activity</h2>
            <p className="mb-6">Are you sure you want to delete <span className="font-semibold">{subActivityToDelete.name}</span>? This action cannot be undone.</p>
            <div className="flex gap-3 justify-center">
              <button onClick={handleDeleteSubActivities} className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700">Delete</button>
              <button onClick={() => { setShowDeleteSubActivitiesModal(false); setSubActivityToDelete(null); }} className="px-6 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300">Cancel</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// Clinical Specialties Modals
export const ClinicalSpecialtiesModals = ({
  showClinicalSpecialtiesModal,
  setShowClinicalSpecialtiesModal,
  showEditClinicalSpecialtiesModal,
  setShowEditClinicalSpecialtiesModal,
  showDeleteClinicalSpecialtiesModal,
  setShowDeleteClinicalSpecialtiesModal,
  clinicalSpecialtiesForm,
  setClinicalSpecialtiesForm,
  clinicalSpecialtiesFormLoading,
  clinicalSpecialtiesFormError,
  handleCreateClinicalSpecialty,
  handleUpdateClinicalSpecialty,
  handleDeleteClinicalSpecialty,
  selectedClinicalSpecialty,
  clinicalSpecialtyToDelete,
  setClinicalSpecialtyToDelete
}) => {
  return (
    <>
      {/* Create Clinical Specialty Modal */}
      {showClinicalSpecialtiesModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-8 w-full max-w-md mx-4 max-h-[85vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold">Add Clinical Specialty</h2>
              <button
                onClick={() => setShowClinicalSpecialtiesModal(false)}
                className="text-slate-400 hover:text-slate-700"
              >
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>
            <form onSubmit={handleCreateClinicalSpecialty}>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Short Description *
                  </label>
                  <input
                    type="text"
                    required
                    value={clinicalSpecialtiesForm.short_description}
                    onChange={(e) => setClinicalSpecialtiesForm({ ...clinicalSpecialtiesForm, short_description: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter short description"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Long Description
                  </label>
                  <textarea
                    value={clinicalSpecialtiesForm.long_description}
                    onChange={(e) => setClinicalSpecialtiesForm({ ...clinicalSpecialtiesForm, long_description: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter long description"
                    rows="4"
                  />
                </div>
              </div>
              {clinicalSpecialtiesFormError && (
                <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                  {clinicalSpecialtiesFormError}
                </div>
              )}
              <div className="flex gap-3 mt-6">
                <button
                  type="submit"
                  disabled={clinicalSpecialtiesFormLoading}
                  className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
                >
                  {clinicalSpecialtiesFormLoading ? "Creating..." : "Create"}
                </button>
                <button
                  type="button"
                  onClick={() => setShowClinicalSpecialtiesModal(false)}
                  className="px-4 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Clinical Specialty Modal */}
      {showEditClinicalSpecialtiesModal && selectedClinicalSpecialty && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-8 w-full max-w-md mx-4 max-h-[85vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold">Edit Clinical Specialty</h2>
              <button
                onClick={() => setShowEditClinicalSpecialtiesModal(false)}
                className="text-slate-400 hover:text-slate-700"
              >
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>
            <form onSubmit={handleUpdateClinicalSpecialty}>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Short Description *
                  </label>
                  <input
                    type="text"
                    required
                    value={clinicalSpecialtiesForm.short_description}
                    onChange={(e) => setClinicalSpecialtiesForm({ ...clinicalSpecialtiesForm, short_description: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter short description"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Long Description
                  </label>
                  <textarea
                    value={clinicalSpecialtiesForm.long_description}
                    onChange={(e) => setClinicalSpecialtiesForm({ ...clinicalSpecialtiesForm, long_description: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter long description"
                    rows="4"
                  />
                </div>
              </div>
              {clinicalSpecialtiesFormError && (
                <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                  {clinicalSpecialtiesFormError}
                </div>
              )}
              <div className="flex gap-3 mt-6">
                <button
                  type="submit"
                  disabled={clinicalSpecialtiesFormLoading}
                  className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
                >
                  {clinicalSpecialtiesFormLoading ? "Saving..." : "Save Changes"}
                </button>
                <button
                  type="button"
                  onClick={() => setShowEditClinicalSpecialtiesModal(false)}
                  className="px-4 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Clinical Specialty Modal */}
      {showDeleteClinicalSpecialtiesModal && clinicalSpecialtyToDelete && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-6 w-full max-w-md mx-4 text-center">
            <h2 className="text-xl font-bold mb-4 text-red-700">Delete Clinical Specialty</h2>
            <p className="mb-6">Are you sure you want to delete <span className="font-semibold">{clinicalSpecialtyToDelete.short_description}</span>? This action cannot be undone.</p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={handleDeleteClinicalSpecialty}
                className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
              >
                Delete
              </button>
              <button
                onClick={() => { setShowDeleteClinicalSpecialtiesModal(false); setClinicalSpecialtyToDelete(null); }}
                className="px-6 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// Documentation Methods Modals
export const DocumentationMethodsModals = ({
  showDocumentationMethodsModal,
  setShowDocumentationMethodsModal,
  showEditDocumentationMethodsModal,
  setShowEditDocumentationMethodsModal,
  showDeleteDocumentationMethodsModal,
  setShowDeleteDocumentationMethodsModal,
  showViewDocumentationMethodModal,
  setShowViewDocumentationMethodModal,
  documentationMethodsForm,
  setDocumentationMethodsForm,
  documentationMethodsFormLoading,
  documentationMethodsFormError,
  handleCreateDocumentationMethod,
  handleUpdateDocumentationMethod,
  handleDeleteDocumentationMethod,
  selectedDocumentationMethod,
  setSelectedDocumentationMethod,
  selectedDocumentationMethodForView,
  documentationMethodToDelete,
  setDocumentationMethodToDelete
}) => {
  return (
    <>
      {/* Create Documentation Method Modal */}
      {showDocumentationMethodsModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-8 w-full max-w-4xl mx-4 max-h-[85vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold">Add Documentation Method</h2>
              <button
                onClick={() => setShowDocumentationMethodsModal(false)}
                className="text-slate-400 hover:text-slate-700"
              >
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>
            <form onSubmit={handleCreateDocumentationMethod}>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Name *
                  </label>
                  <input
                    type="text"
                    required
                    value={documentationMethodsForm.name}
                    onChange={(e) => setDocumentationMethodsForm({ ...documentationMethodsForm, name: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Session Instructions
                  </label>
                  <div className="relative">
                    <div className="absolute top-3 left-3 text-gray-500 text-sm pointer-events-none z-10">
                      REQUIRED SECTIONS - Please fill in all three sections in that format below:
                    </div>
                    <textarea
                      value={documentationMethodsForm.session_instructions}
                      onChange={(e) => setDocumentationMethodsForm({ ...documentationMethodsForm, session_instructions: e.target.value })}
                      className="w-full px-3 py-2 pt-8 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      rows="25"
                    />
                  </div>
                </div>
              </div>
              {documentationMethodsFormError && (
                <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                  {documentationMethodsFormError}
                </div>
              )}
              <div className="flex gap-3 mt-6">
                <button
                  type="submit"
                  disabled={documentationMethodsFormLoading}
                  className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
                >
                  {documentationMethodsFormLoading ? "Creating..." : "Create"}
                </button>
                <button
                  type="button"
                  onClick={() => setShowDocumentationMethodsModal(false)}
                  className="px-4 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Edit Documentation Method Modal */}
      {showEditDocumentationMethodsModal && selectedDocumentationMethod && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-8 w-full max-w-4xl mx-4 max-h-[85vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h2 className="text-xl font-bold">Edit Documentation Method</h2>
              <button
                onClick={() => {
                  setShowEditDocumentationMethodsModal(false);
                  setDocumentationMethodsForm({ name: "", session_instructions: "" });
                  setSelectedDocumentationMethod(null);
                }}
                className="text-slate-400 hover:text-slate-700"
              >
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>
            <form onSubmit={handleUpdateDocumentationMethod}>
              <div className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Name *
                  </label>
                  <input
                    type="text"
                    required
                    value={documentationMethodsForm.name}
                    onChange={(e) => setDocumentationMethodsForm({ ...documentationMethodsForm, name: e.target.value })}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Enter name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Session Instructions
                  </label>
                  <div className="relative">
                    <div className="absolute top-3 left-3 text-gray-500 text-sm pointer-events-none z-10">
                      REQUIRED SECTIONS - Please fill in all three sections in that format below:
                    </div>
                    <textarea
                      value={documentationMethodsForm.session_instructions}
                      onChange={(e) => setDocumentationMethodsForm({ ...documentationMethodsForm, session_instructions: e.target.value })}
                      className="w-full px-3 py-2 pt-8 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      rows="25"
                    />
                  </div>
                </div>
              </div>
              {documentationMethodsFormError && (
                <div className="mt-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-700 text-sm">
                  {documentationMethodsFormError}
                </div>
              )}
              <div className="flex gap-3 mt-6">
                <button
                  type="submit"
                  disabled={documentationMethodsFormLoading}
                  className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50"
                >
                  {documentationMethodsFormLoading ? "Saving..." : "Save Changes"}
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setShowEditDocumentationMethodsModal(false);
                    setDocumentationMethodsForm({ name: "", session_instructions: "" });
                    setSelectedDocumentationMethod(null);
                  }}
                  className="px-4 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Delete Documentation Method Modal */}
      {showDeleteDocumentationMethodsModal && documentationMethodToDelete && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-6 w-full max-w-md mx-4 text-center">
            <h2 className="text-xl font-bold mb-4 text-red-700">Delete Documentation Method</h2>
            <p className="mb-6">Are you sure you want to delete <span className="font-semibold">{documentationMethodToDelete.name}</span>? This action cannot be undone.</p>
            <div className="flex gap-3 justify-center">
              <button
                onClick={handleDeleteDocumentationMethod}
                className="px-6 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
              >
                Delete
              </button>
              <button
                onClick={() => { setShowDeleteDocumentationMethodsModal(false); setDocumentationMethodToDelete(null); }}
                className="px-6 py-2 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}

      {/* View Documentation Method Modal */}
      {showViewDocumentationMethodModal && selectedDocumentationMethodForView && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-8">
          <div className="bg-white rounded-xl p-8 w-full max-w-4xl mx-4 max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-2xl font-bold text-slate-800">View Documentation Method</h2>
              <button
                onClick={() => setShowViewDocumentationMethodModal(false)}
                className="text-slate-400 hover:text-slate-700 transition-colors"
              >
                <XMarkIcon className="w-6 h-6" />
              </button>
            </div>
            
            <div className="space-y-6">
              {/* Name */}
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-2">
                  Name
                </label>
                <div className="p-4 bg-slate-50 border border-slate-200 rounded-lg">
                  <span className="text-lg font-medium text-slate-900">
                    {selectedDocumentationMethodForView.name}
                  </span>
                </div>
              </div>

              {/* Session Instructions */}
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-2">
                  Session Instructions
                </label>
                <div className="p-4 bg-slate-50 border border-slate-200 rounded-lg max-h-96 overflow-y-auto">
                  <pre className="whitespace-pre-wrap text-slate-700 font-mono text-sm leading-relaxed">
                    {selectedDocumentationMethodForView.session_instructions}
                  </pre>
                </div>
              </div>

              {/* Created Date */}
              <div>
                <label className="block text-sm font-semibold text-slate-700 mb-2">
                  Created
                </label>
                <div className="p-4 bg-slate-50 border border-slate-200 rounded-lg">
                  <span className="text-slate-700">
                    {new Date(selectedDocumentationMethodForView.created_at).toLocaleDateString('en-US', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </span>
                </div>
              </div>
            </div>

            {/* Close Button */}
            <div className="flex justify-end mt-8 pt-6 border-t border-slate-200">
              <button
                onClick={() => setShowViewDocumentationMethodModal(false)}
                className="px-6 py-2 bg-slate-600 text-white rounded-lg hover:bg-slate-700 transition-colors"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
